import { useMemo } from "react";
import { useEarningGroupsContext } from "../../../earningGroupsContext"
import { renderDurationAsFormat } from "../../../../../utils/helpers/date";
import { currencyFormatter } from "../../../../../utils/helpers/currencyFormatter";

const getCellValue = (item, overall) => {
    const value = overall?.find((i) => i.earningGroup === item.id);

    if (!item.display || item.display === "duration") {
        if (value && value?.duration > 0) {
            return renderDurationAsFormat(value?.duration, "HH:mm")
        } else {
            return "--"
        }
    } else {
        if (value && value?.total > 0) {
            return currencyFormatter(value?.total, 2, 'usd');
        } else {
            return "--"
        }
    }
}

const getFooterValue = (item, data) => {
    let total = 0;
    data?.forEach(({ overall }) => overall?.forEach((i) => {
        if (item.id === i.earningGroup) {
            if (!item.display || item.display === "duration") {
                total += i.duration
            } else {
                total += i.total
            }
        }
    }))
    if (total > 0) {
        if (!item.display || item.display === "duration") {
            return renderDurationAsFormat(total, "HH:mm")
        } else {
            return currencyFormatter(total, 2, 'usd');
        }
    } else {
        return "--"
    }
}

export const useEarningGroupsColumns = ({ canViewRates } = {}) => {
    const { data } = useEarningGroupsContext();

    return useMemo(() => {
        if (!data) {
            return [];
        }
        return data
            .filter((item) => {
                if (item.display === "total") {
                    return canViewRates;
                }
                return true;
            })
            .map((item) => ({
                Header: item.code,
                accessor: item.id,
                id: item.id,
                Cell: ({ row: { original } }) => {
                    return getCellValue(item, original?.overall);
                },
                Footer: ({ data }) => getFooterValue(item, data)
            }));
    }, [data]);
}
